/**
 * this file contains all redux-saga watchers & workers for the reports
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Paul on 04/07/19
 */

import { takeEvery, call, put } from 'redux-saga/effects'

import C from '../constants'
import config from '../config'
import { request, isEmpty, substitute } from '../utility/utilities'


/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF REPORTS
----------------------------------------------------------------------------- */

// watcher saga for requesting a report
export function* watchRequestReport() {
    yield takeEvery(C.REQUEST_REPORT, workerRequestReport)
}

// worker saga for fetching biling data
function* workerRequestReport(action) {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = substitute(config.endpoints.reportRequestURL, { fund_code: action.payload.fund_code, report_name: action.payload.report_name })

    try {
        // get the response promise object
        const response = yield call(request, requestURL, headers)

    } catch (error) {
        console.log(error)
    } finally {
        
    }
}



// WEBPACK FOOTER //
// ./src/sagas/reportSaga.js